const SignupFaqContent = [
  {
    title: 'Do I have to pay any upfront fees or security deposits?',
    info: [
      {
        pretext:
          'No, there are no upfront fees or deposits when signing up or creating a booking with Autzu. Charges are only applied two hours before the commencement of your booking appointment.'
      }
    ]
  },
  {
    title: 'How do I set up an Autzu account?',
    info: [
      {
        pretext:
          'There are 4 easy steps to set up your Autzu account and begin driving:'
      },
      {
        text: [
          {
            boldtext: 'Download and Sign Up: ',
            plaintext: 'Start by downloading the Autzu app and sign up.'
          },
          {
            boldtext: 'Identity Verification: ',
            plaintext:
              "Verify your identity using your driver's license and provide a clear picture of your face."
          },
          {
            boldtext: 'Connect Rideshare Account: ',
            plaintext:
              'Link your active rideshare driver account to Autzu.'
          },
          {
            boldtext: 'Start Booking: ',
            plaintext:
              "You're ready to start booking vehicles through the Autzu app."
          }
        ]
      }
    ]
  },
  {
    title: 'How soon can I begin driving?',
    info: [
      {
        pretext:
          'If you already have an active rideshare driver account, you can begin driving with Autzu immediately.'
      },
      {
        posttext:
          'If you do not already have a rideshare driver account, you will need to sign up with the rideshare company and complete your background check.'
      }
    ]
  },
  {
    title: 'How do I set up a rideshare driver account?',
    info: [
      {
        pretext:
          'To set up a rideshare driver account with Uber, follow these steps:'
      },
      {
        text: [
          {
            boldtext: 'Create an Uber Driver account: ',
            plaintext:
              'Download and open the Uber Driver app on your mobile device.'
          },
          {
            boldtext: 'Upload Personal Documents: ',
            plaintext:
              'Upload your Ontario driver’s license (Class G or above), proof of work eligibility (like a passport), and a clear profile picture.'
          },
          {
            boldtext: 'Receive Vehicle Documents: ',
            plaintext:
              'Autzu will send you an email containing vehicle documents, including registration, insurance, and safety inspection to upload to the Uber Driver app.'
          },
          {
            boldtext: 'Background Check: ',
            plaintext:
              'Once all documents are submitted and approved, you will receive an email to complete your background check.'
          }
        ]
      }
    ]
  },
  {
    title: 'Why do I need to connect my rideshare driver account?',
    info: [
      {
        pretext:
          'Connecting your rideshare driver account to Autzu is necessary for the following reasons:'
      },
      {
        text: {
          boldtext: 'Vehicle Assignment: ',
          plaintext:
            "By connecting your rideshare driver account, Autzu can assign you to one of their vehicles and communicate this information to the rideshare company. This ensures that you can use Autzu's vehicles for your rideshare driving."
        }
      },
      {
        text: {
          boldtext: 'Compliance: ',
          plaintext:
            "Rideshare companies need to know the details of the vehicle you're driving, including the make, model, license plate, and insurance information. Connecting your account allows Autzu to share this information with the rideshare company on your behalf."
        }
      },
      {
        posttext:
          "It's important to note that Autzu does not modify your profile, collect your rideshare earnings, or interfere with your rideshare driver account. The connection is purely for vehicle assignment and compliance purposes."
      }
    ]
  }
];

export default SignupFaqContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/SignupFaqContentOTT.js